/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { CommonDataPayload, PageDataPayload, UserDataPayload } from '@/data/types/GTM';

export const getGTMCommonEventData = async (payload: CommonDataPayload) => {

	const { storeId, language, environment, currency, locale, country, device } = payload;    
	return {storeId, language, environment, currency, locale, country, device };
};
 
export const getGTMXPageViewEventData = async (payload: PageDataPayload) => {

	const { pageName, pageType } = payload;    
	return { pageName, pageType };
};
export const getGTMUserDataEventData = async (payload: UserDataPayload) => {

	const { userId, userType } = payload;    
	return { userId, userType };
};